export default __webpack_public_path__ + "static/media/2331.6585ca34.png";